module.exports = __webpack_public_path__ + "static/media/alhad_deodhar.6cc8ca85.png";